import axios from "axios";

const api = axios.create({
  //baseURL: "http://localhost:5000/api",
  baseURL: "https://hilandbackend-f17ef7cea8be.herokuapp.com/api",
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("crew_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // The keys here were "token"/"user", but auth stores "crew_token"/"crew_user",
    // so an expired session never signed the user out — they just watched every
    // screen fail silently until they cleared the app data.
    const token = localStorage.getItem("crew_token");

    if (err.response?.status === 401 && token) {
      localStorage.removeItem("crew_token");
      localStorage.removeItem("crew_user");
      window.location.href = "/login";
    }

    return Promise.reject(err);
  }
);

export default api;